export default __webpack_public_path__ + "static/media/s14.8594fcea.jpg";